/**
 * useAdminMenuPreference + useAvailableAdminMenuLayouts (ADR-0034).
 *
 * `useAdminMenuPreference` — GET /api/admin/menu/preference (own admin layoutId).
 * `useAvailableAdminMenuLayouts` — GET /api/admin/menu/preference/available (lista
 *   layoutów dostępnych dla aktualnego admina, do AdminLayoutSwitcherFooter).
 */

import type { AdminMenuLayoutSummary } from '@saas/shared';
import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';

export const ADMIN_MENU_PREFERENCE_KEY = ['admin', 'menu', 'preference'] as const;
export const AVAILABLE_ADMIN_MENU_LAYOUTS_KEY = [
  'admin',
  'menu',
  'preference',
  'available',
] as const;

export interface AdminMenuPreferenceResponse {
  layoutId: string | null;
}

export interface AvailableAdminMenuLayoutsResponse {
  layouts: AdminMenuLayoutSummary[];
}

export function useAdminMenuPreference() {
  return useQuery<AdminMenuPreferenceResponse>({
    queryKey: ADMIN_MENU_PREFERENCE_KEY,
    queryFn: async () => {
      const res = await api.get<AdminMenuPreferenceResponse>('/admin/menu/preference');
      return res.data;
    },
    staleTime: 30_000,
  });
}

export function useAvailableAdminMenuLayouts() {
  return useQuery<AvailableAdminMenuLayoutsResponse>({
    queryKey: AVAILABLE_ADMIN_MENU_LAYOUTS_KEY,
    queryFn: async () => {
      const res = await api.get<AvailableAdminMenuLayoutsResponse>(
        '/admin/menu/preference/available',
      );
      return res.data;
    },
    staleTime: 30_000,
  });
}
